import { useTranslation } from "react-i18next";
import { getImageSrcFromBase64 } from "../../../shared/lib/get-image-src-form-base-64";
import fakedoorImage from "../assets/wait-icon.png";

type FakedoorDesktopProps = {
  linkQr: string;
};

export const FakedoorDesktop = ({ linkQr }: FakedoorDesktopProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex max-w-[464px] flex-col items-center gap-4 text-center">
      <img className="block w-[116px]" src={fakedoorImage} alt="logo" />
      <p className="typography-big-text-semibold px-10 ">
        {t("fakedoor.title")}
      </p>
      <p className="typography-regular-text-regular px-22">
        {t("fakedoor.desktop.subtitle")}
      </p>
      {linkQr ? (
        <div className="flex h-[231px] w-[232px] items-center justify-center rounded-lg bg-background-neutral">
          <img
            className="h-[184px] w-[184px] bg-background-neutral-subtle"
            src={getImageSrcFromBase64(linkQr)}
            alt="qr"
          />
        </div>
      ) : null}
    </div>
  );
};
